<template>
    <section :class="namespace()">
        <div :class="[namespace('item')]">
            <label
                :class="[mdsNS('form__label')]"
                :for="guid + '_selectColumn'"
                >{{ lables.selectSortField }}</label
            >
        </div>
        <div :class="[namespace('item')]">
            <markets-ui-select
                :id="guid + '_selectColumn'"
                :namespaced="namespaced"
                :skin="skin"
                :dataModel="fields"
                @change="changeSortField"
            ></markets-ui-select>
        </div>
        <div :class="[namespace('item')]">
            <label :class="[mdsNS('form__label')]" :for="guid + '_selectOrder'">
                {{ lables.selectSortOrder }}
            </label>
        </div>
        <div :class="[namespace('item')]">
            <markets-ui-radio-button-group
                :id="guid + '_selectOrder'"
                :namespaced="namespaced"
                :skin="skin"
                :dataModel="orders"
                @change="changeSortOrder"
            ></markets-ui-radio-button-group>
        </div>
    </section>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-sort',
    mixins: [mixins],
    props: {
        lables: {
            type: Object,
            default() {
                return {
                    selectSortField: 'Select sort field',
                    selectSortOrder: 'Select sort order'
                };
            }
        },
        fields: {
            type: Array,
            required: true
        },
        orders: {
            type: Array,
            required: true
        }
    },
    created() {
        this.guid = utils.guid();
        this.namespace = utils.namespace('ui-sort', false);
    },
    methods: {
        changeSortField(filed) {
            const order = this.orders.find(order => order.selected);
            this.$emit('change', filed, order);
        },
        changeSortOrder(order) {
            const filed = this.fields.find(filed => filed.selected);
            this.$emit('change', filed, order);
        }
    }
};
</script>

<style lang="scss">
$namespace: 'markets-ui-sort';
.#{$namespace} {
    &-item {
        margin-bottom: 12px;
    }
}
</style>
